import '@babel/polyfill'
import 'nodelist-foreach-polyfill'
import Swiper from 'swiper'

const selectors = {
  el: '[data-menu]',
  openButton: '[data-menu-open]',
  closeButton: '[data-menu-close]'
}

export default () => {
  const _html = document.documentElement;
  const el = document.querySelector(selectors.el)
  const openButton = document.querySelector(selectors.openButton)
  const closeButton = document.querySelector(selectors.closeButton)

  if (!el) {
    return
  }

  openButton.addEventListener('click', (e) => {
    e.preventDefault()
    el.classList.add('-active')
    _html.classList.add('c-menu-is-open')
  })

  closeButton.addEventListener('click', (e) => {
    e.preventDefault()
    el.classList.remove('-active')
    _html.classList.remove('c-menu-is-open')
  })
}
